import * as PIXI from 'pixi.js';
import Config from './Config';
import * as Sounds from './Sounds';

export default class Treasure extends PIXI.Container {
  constructor(x, y) {
    super();

    this.collectSound = new Howl({
      autoplay: false,
      src: ['game/sounds/collect.mp3', 'game/sounds/collect.ogg', 'game/sounds/collect.wav'],
    });

    this.elapsedTime = 0;
    this.isCollected = false;
    this.sprite = null;
    this.initialX = x;

    this.position.set(x, y);

    this.onResourcesLoaded();
  }

  onResourcesLoaded() {
    this.sprite = new PIXI.AnimatedSprite(PIXI.Loader.shared.resources['treasure'].spritesheet.animations['crystal_idle']);
    this.sprite.anchor.set(0.5, 0.5);
    this.sprite.loop = true;
    this.sprite.animationSpeed = 24 / 60; // TODO: ???
    this.sprite.play();

    this.addChild(this.sprite);

    // this.graphics = new PIXI.Graphics();
    // this.graphics.beginFill(0x0000ff);
    // this.graphics.drawRect(-Config.TREASURE_WIDTH / 2, -Config.TREASURE_HEIGHT / 2, Config.TREASURE_WIDTH, Config.TREASURE_HEIGHT);
    // this.graphics.endFill();

    // this.addChild(this.graphics);
  }

  update(dt, [
    background,
    foreground,
    player,
    ground,
    ...treasures
  ]) {
    const playerOnscreenX = Config.PLAYER_ONSCREEN_POSITION * Config.GAME_WIDTH;

    this.elapsedTime = (this.elapsedTime + dt) % Config.TREASURE_FLOAT_PERIOD;

    this.position.x = this.initialX - player.positionX;

    if (this.sprite) {
      this.sprite.position.y = Config.TREASURE_FLOAT_AMPLITUDE * Math.sin((this.elapsedTime * 2 * Math.PI) / Config.TREASURE_FLOAT_PERIOD);
    }

    if (this.isCollected) {
      this.rotation = this.rotation + Config.TREASURE_COLLECTED_ROTATION_SPEED * dt;
      this.alpha = Math.max(0, this.alpha - dt / Config.TREASURE_COLLECTED_FADE_OUT_DURATION);
    } else {
      if (player.isDead) return;

      const closestX = Math.max(this.position.x - Config.TREASURE_WIDTH / 2, Math.min(playerOnscreenX, this.position.x + Config.TREASURE_WIDTH / 2));
      const closestY = Math.max(this.position.y - Config.TREASURE_HEIGHT / 2, Math.min(player.position.y, this.position.y + Config.TREASURE_HEIGHT / 2));

      const distanceX = playerOnscreenX - closestX;
      const distanceY = player.position.y - closestY;

      const distanceSquared = distanceX * distanceX + distanceY * distanceY;

      const isColliding = distanceSquared < (Config.PLAYER_RADIUS * Config.PLAYER_RADIUS);

      if (isColliding) {
        this.isCollected = true;

        Sounds.collect.play();

        player.addEnergy(Config.TREASURE_ENERGY);
        player.addScore(Config.TREASURE_SCORE);
      }
    }
  }
}
